import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import { EnergyStatus } from "api/onboardingTypes";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  buttonText: "Continuar",
  nextScreen: "building-avatar",
  skipTo: "building-avatar",
  imgSrc: "/static/img/solutions/green-energy.png",
  h2Subtitle: "Possui contrato de energia verde?",
};

const TENSION_DATA: Array<{ value: EnergyStatus; text: string }> = [
  {
    value: "solarFarm",
    text: "Sim, com Fazenda solar",
  },
  {
    value: "freeMarket",
    text: "Sim, no mercado livre",
  },
  {
    value: "no",
    text: "Não possuo",
  },
  {
    value: "idk",
    text: "Não sei",
  },
];

export const GreenEnergyStatus = ({ history }) => {
  const [tension, setTension] = useState<EnergyStatus>();
  const [discountPercent, setDiscountPercent] = useState<string>("");
  const { setEnergyContractStatus, setDiscount } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleSubmit = () => {
    if (tension) {
      setEnergyContractStatus(tension);
      setDiscount(discountPercent);
      history.push(FRAME_DATA.nextScreen);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleSubmit}>
      <BlockStandard hideDivider>
        <List>
          {TENSION_DATA.map(({ value, text }) => (
            <ListItem
              disablePadding
              key={value}
              sx={{
                border: `1px solid ${hasFormError && !tension ? "red" : "#595959"}`,
                borderRadius: "12px",
                mb: 2,
              }}
            >
              <ListItemButton onClick={() => setTension(value)}>
                <ListItemIcon>
                  <Checkbox
                    sx={{ color: "#595959" }}
                    color="success"
                    edge="start"
                    checked={tension === value}
                  />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </BlockStandard>

      {(tension === "solarFarm" || tension === "freeMarket") && (
        <BlockStandard hideDivider>
          <Typography variant="h2">Qual % de desconto estimado?</Typography>
          <TextField
            variant="outlined"
            placeholder="%"
            value={discountPercent}
            onChange={({ target }) => setDiscountPercent(target.value)}
          />
        </BlockStandard>
      )}
    </SolutionsFrame>
  );
};
